import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const TeamMembersSkillsApi = createApi({
  reducerPath: "teamMemberSkillsApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getReporteesSkillList: builder.query({
      query: ({ userId, name, pageNumber, userName, skills }: any) => ({
        url: "/graphql",
        body: gql`
        query{
            fetchReporteesSkills(request:{
            supervisorid:"${userId}", 
                userName:"${userName}",
                skills:${skills ? `["${skills}"]` : "[]"}
          },
          criteria:{
              sortKey:"email",
              order:"ASC",
              pageNo:${pageNumber},
              pageCount:10
            }){
              timestamp
              version
              error
              data{
                myReportees{
                  userId
                  name{fullName}
                  email
                  profileImageUrl
                  employment{
                    bg
                    du
                    band
                    role
                    grade
                    title
                    clientName
                    designation
                    organization
                    operatingUnit
                    assignmentStatus
                  }      
                  skills{
                    userId
                    skillId
                    skillName
                    proficiency
                    verified
                    source
                  }
                  assignments {
                    artifactId
                    artifactType
                    title
                    shortDescription
                    longDescription
                    language
                    duration
                    difficultyLevel
                    branding {
                      banner
                      thumbnail
                      promo
                    }
                    sourceName
                    sourceType
                    prerequisite
                    learningObjective
                    demonstrableOutcome
                    brandingurls {
                      banner
                      thumbnail
                      promo
                    }
                    searchTags {
                      defaultTag
                    }
                    progressPercentage
                    progressStatus
                  }
                  assigned
                  selfLearning
                  inProgress
                  completed
                }
                pageNumber
                pageSize
                totalCount
              }
            }
            
          }
        `
      }),
      extraOptions: { service: "Catalog" },
      serializeQueryArgs: ({ endpointName }) => {
        return { endpointName };
      },
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs?.arg?.pageNumber > 0) {
          const messageMap = new Map();
          [
            ...currentCacheData.fetchReporteesSkills.data.myReportees,
            ...responseData.fetchReporteesSkills.data.myReportees
          ].map((msg) => {
            if (!messageMap.has(msg.userId)) {
              messageMap.set(msg.userId, msg);
            }
          });
          const mergedResult = [...messageMap.values()];
          return {
            ...responseData,
            fetchReporteesSkills: {
              ...responseData.fetchReporteesSkills,
              data: {
                ...responseData.fetchReporteesSkills.data,
                myReportees: mergedResult
              }
            }
          };
        } else return responseData;
      }
    })
  })
});

export const {
  useGetReporteesSkillListQuery,
  useLazyGetReporteesSkillListQuery
} = TeamMembersSkillsApi;
